import {
  BackgroundImage,
  Center,
  Text,
  Box,
  Button,
  Group,
  Card,
  Grid,
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import test from "assets/images/pngs/test1.png";
import background from "assets/images/pngs/background.png";
import React from "react";
import { UseFormReturnType } from "@mantine/form";
import { IForm } from "../type";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { beText } from "@/utils/beText";

interface Props {
  form: UseFormReturnType<IForm>;
  onSubmit: () => void;
}
const TermDepositStepThree: React.FC<Props> = ({ form, onSubmit }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [stateSavingStore] = useSavingStore();

  return (
    <Group position="center">
      <Card withBorder shadow="sm" radius="md" pb="20px" w="50%">
        <div className="flex flex-col content-center gap-2 bg-white w-full">
          <div className="flex flex-col justify-center items-center">
            <img src={test} alt="test" className="my-2 h-48 w-48" />
            <Text weight={600}>
              {t("ORDER_CREATED_SUCCESSFULLY_AND_AWAITING_APPROVAL")}
            </Text>
          </div>
          <Box w="100%">
            <BackgroundImage src={background} radius="md" className="w-full">
              <Center p="lg">
                <Text size={32} weight={800} sx={{ color: "white" }}>
                  {stateSavingStore.savingDetail.savingAmountDisplay}
                </Text>
              </Center>
            </BackgroundImage>
          </Box>
        </div>
        <Box m="40px">
          {stateSavingStore.detailParams &&
            stateSavingStore.detailParams.map((item) => (
              <DetailItem
                key={item.key}
                label={beText(item.key)}
                content={beText(item.value)}
              />
            ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <div
            className="flex items-center justify-between gap-4 mt-4"
            style={{ width: "100%" }}
          >
            <Button
              variant="white"
              sx={{
                color: "black",
                width: "50%",
                borderRadius: "8px",
                background: "#F4F4F6",
                "&:hover": {
                  backgroundColor: "#F4F4F6",
                },
              }}
              fullWidth
              onClick={() => {
                navigate("/");
              }}
            >
              {t("HOME")}
            </Button>
            <Button
              variant="filled"
              onClick={onSubmit}
              sx={{
                width: "50%",
                backgroundColor: "#2A81D0",
                borderRadius: "8px",
                "&:hover": {
                  backgroundColor: "#1E679E",
                },
              }}
              fullWidth
            >
              {t("TRANSACTION_LIST")}
            </Button>
          </div>
        </Box>
      </Card>
    </Group>
  );
};

const DetailItem = ({ label, content }: { label: string; content: string }) => {
  return (
    <Grid gutter="xs" align="center" style={{ marginBottom: "16px" }}>
      <Grid.Col span={6} style={{ textAlign: "left" }}>
        <Text size="16px" color="#0E121B">
          {label}
        </Text>
      </Grid.Col>

      <Grid.Col span={6} style={{ textAlign: "right" }}>
        <Text size="16px" weight={600} color="#0E121B">
          {content}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

export default TermDepositStepThree;
